import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById('hero-section');
      const pricingSection = document.getElementById('pricing');
      if (!heroSection || !pricingSection) return;
      const heroBottom = heroSection.getBoundingClientRect().bottom;
      const pricingTop = pricingSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      if (heroBottom < 0 && pricingTop > windowHeight) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-425">
      {isVisible}
    </AnimatePresence>;
}